import { MapPin, Mail } from "lucide-react";

export const FooterContact = () => {
  return (
    <div>
      <h4 className="font-semibold mb-4">Contacto</h4>
      <ul className="space-y-2 text-sm">
        <li className="flex items-start gap-2 text-muted-foreground">
          <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0" aria-hidden="true" />
          <div>
            <div>Terra Incognita Creations LLC</div>
            <div>407 Lincoln Road Suite 708</div>
            <div>Miami Beach FL 33139</div>
            <div>Miami-Dade, United States</div>
          </div>
        </li>
        <li className="flex items-center gap-2 text-muted-foreground">
          <Mail className="w-4 h-4 flex-shrink-0" aria-hidden="true" />
          <a
            href="mailto:info@appeo.es"
            className="hover:text-primary transition-colors"
            aria-label="Enviar correo electrónico a info@appeo.es"
          >
            info@appeo.es
          </a>
        </li>
      </ul>
    </div>
  );
};
